import Vue from "vue";
import VueMatomo from "vue-matomo";

export default ({ app }) => {
    const { matomo } = app.$config;

    if (!matomo.siteId || !matomo.url) {
        return;
    }

    Vue.use(VueMatomo, {
        // Configure your matomo server and site by providing
        host: matomo.url,
        siteId: matomo.siteId,

        // Enables automatically registering pageviews on the router
        router: app.router
    });
};
